<template>
    <div class="flex items-center justify-center h-full">
        <div class="flex flex-col items-start gap-8 max-w-2xl">
            <div class="flex flex-col gap-2 items-start">
                <UiText as="h3" class="font-normal text-primary" text="Application successfully submitted!" />

                <UiText as="p" class="text-primary"
                    text="Our team will thoroughly review your application details. We're excited about the possibility of welcoming you into our vetted network soon. Thanks for your patience!" />
            </div>
            <UiButton variant="outline" label="Back to Website" @click="goToWebsite" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { UiButton, UiText } from "@shopexperts/shared"

const router = useRouter()

const goToWebsite = () => {
    router.push('/')
}
</script>
